// Debounce til genberegning af "Mål areal og volumen" efter en geometri-ændring: mange hurtige ændringer (fx flere
// menu-handlinger i træk, eller et nyt slip lige efter et andet) giver ÉN genberegning, der starter, når der har været ro i
// `delayMs`. Ren logik (timerne er injicerbare) - volumeTool.js ejer selve beregningen. Et vertex-slip kalder schedule(0).
export function createRecomputeScheduler({run, delayMs = 250, setTimer = setTimeout, clearTimer = clearTimeout}){
	let timer = null;

	return {
		schedule(delay = delayMs){
			if(timer !== null) clearTimer(timer);
			timer = setTimer(() => {
				timer = null;
				run();
			}, delay);
		},
		cancel(){
			if(timer !== null){
				clearTimer(timer);
				timer = null;
			}
		},
		get pending(){
			return timer !== null;
		},
	};
}
